import React from "react";
import { Icon } from "@iconify/react";

const CustomizableDashComponent = () => {
    return (
        <div className="md:h-screen flex items-center w-11/12">
          <div>
              <h2 className="text-[#036F36] text-lg md:text-xl lg:text-3xl mb-3">
                Unpacking the Policy Landscape
              </h2>
              <p className="text-lg md:text-xl lg:text-2xl">
              Navigate the complex world of agricultural policies with a structured approach. Our policy landscaping organizes, classifies, and simplifies the frameworks shaping agri-food systems - helping you see the bigger picture and drive informed action.
              </p>
              <a href="/home-landscape">
                <button className="common-button mt-3 ml-0 text-base md:text-lg lg:text-xl">
                    See the Big Picture
                    <Icon icon="maki:arrow" width="12" height="12" className="ml-2"/>
                </button>
              </a>
          </div>
        </div>
    );
};

export default CustomizableDashComponent;